
import { VenuesOrg } from '../VenuesOrg';

export class VenuesOrgPartner extends VenuesOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/VenuesOrgPartner.js